import { render } from "./OtiActionsSmall.vue?vue&type=template&id=92ca856e&scoped=true"
import script from "./OtiActionsSmall.vue?vue&type=script&lang=js"
export * from "./OtiActionsSmall.vue?vue&type=script&lang=js"

import "./OtiActionsSmall.vue?vue&type=style&index=0&id=92ca856e&lang=scss&scoped=true"

import exportComponent from "D:\\OSOLE\\metalpro\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92ca856e"]])

export default __exports__